import React from "react";

// import { HeadlineLinkRecord } from "../../../../state/detail";
// import { EventDetail } from "../../../../types";
// import { HeadlineBlock } from "../../../atoms/headlineBlock";
// import { ImageBlock } from "../../../atoms/imageBlock";
// import { LinkBlock } from "../../../atoms/linkBlock";
// import { TextBlock } from "../../../atoms/textBlock";
// import { VideoBlock } from "../../../atoms/videoBlock";
// import { BlockQuote } from "../../../molecules/blockQuote";
// import { SpeakerBlock } from "../../../molecules/speakerBlock";
// import { TableOfContents } from "../../../molecules/tableOfContents";
import styles from "./EventContent.module.scss";
import { ContentHeadlineItem, EventDetail } from "../../types";
import { TableOfContents } from "../../components/molecules/tableOfContents";
import { HeadlineBlock } from "../../components/atoms/headlineBlock";
import { VideoBlock } from "../../components/atoms/videoBlock";
import { ImageBlock } from "../../components/atoms/imageBlock";
import { TextBlock } from "../../components/atoms/textBlock";
import { LinkBlock } from "../../components/atoms/linkBlock";
import { SpeakerBlock } from "../../components/molecules/speakerBlock";
import { BlockQuote } from "../../components/molecules/blockQuote";

interface Props {
  activeHeadline: number;
  event: EventDetail;
  headlines: Array<ContentHeadlineItem>;
  goToHeadline: (id: number) => void;
  isMobile: boolean | null;
  setHeadlineRef: (id: number, elem: HTMLDivElement | null) => void;
}

const EventContent: React.FC<Props> = (props) => {
  const {
    activeHeadline,
    event,
    goToHeadline,
    headlines,
    setHeadlineRef,
    isMobile,
  } = props;

  if (!event.contents.length) {
    return null;
  }

  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <div className={styles.tableOfContentsMobile}>
          <TableOfContents
            active={activeHeadline}
            onClick={goToHeadline}
            headlines={headlines}
          />
        </div>
      </div>
      {event.contents
        .map((content) => content.contentInstance)
        .map((content, i) => (
          <div className={styles.container} key={i}>
            {content.__typename === "ContentHeadline" ? (
              <HeadlineBlock
                hasRule={true}
                label={content.text}
                setRef={(elem) => {
                  setHeadlineRef(content.id, elem);
                }}
              />
            ) : null}
            {content.__typename === "ContentVideo" ? (
              <VideoBlock src={content.url} />
            ) : null}
            {content.__typename === "ContentImage" ? (
              <ImageBlock
                forceRatio
                src={content.imageUrl}
                caption={content.caption}
              />
            ) : null}
            {content.__typename === "ContentText" ? (
              <TextBlock text={content.body} />
            ) : null}
            {content.__typename === "ContentLink" ? (
              <LinkBlock
                ogp={{
                  image: content.linkImageUrl,
                  description: content.description,
                  title: content.title,
                }}
                url={content.url}
              />
            ) : null}
            {content.__typename === "ContentSpeaker" ? (
              <SpeakerBlock
                speakerName={content.name}
                companyName={content.companyName}
                imageUrl={content.speakerImageUrl || null}
                profile={content.profile}
                isMobile={isMobile}
              />
            ) : null}
            {content.__typename === "ContentQuotation" ? (
              <BlockQuote text={content.text} source={content.source} />
            ) : null}
          </div>
        ))}
    </div>
  );
};

export default EventContent;
